import { FORMA_PAGAMENTO_ROTULO, formatarReais } from "@caixaflow/shared";
import type { CaixaDetalhe, LinhaFechamento } from "../api/tipos";

/** "+R$ 1,00 sobra", "−R$ 5,00 falta" ou "confere". */
export function Diferenca({ centavos }: { centavos: number }) {
  if (centavos === 0) return <span className="diferenca confere">confere</span>;
  const classe = centavos > 0 ? "sobra" : "falta";
  return (
    <span className={`diferenca ${classe}`}>
      {centavos > 0 ? "+" : "−"}
      {formatarReais(Math.abs(centavos))} {classe}
    </span>
  );
}

export function IndicadoresCaixa({ totais }: { totais: CaixaDetalhe["resumo"]["totais"] }) {
  return (
    <div className="kpis">
      <div className="kpi hl">
        <span>Total vendido</span>
        <b>{formatarReais(totais.totalCentavos)}</b>
      </div>
      <div className="kpi">
        <span>Vendas</span>
        <b>{totais.vendas}</b>
      </div>
      <div className="kpi">
        <span>Itens vendidos</span>
        <b>{totais.itens}</b>
      </div>
      <div className="kpi">
        <span>Ticket médio</span>
        <b>{formatarReais(totais.ticketMedioCentavos)}</b>
      </div>
      <div className="kpi">
        <span>Canceladas</span>
        <b>{totais.canceladas.quantidade}</b>
      </div>
    </div>
  );
}

/** Esperado × contado × diferença por forma de pagamento (comprovante de fechamento). */
export function TabelaFechamento({ linhas }: { linhas: LinhaFechamento[] }) {
  const soma = (campo: "esperadoCentavos" | "contadoCentavos" | "diferencaCentavos" | "quantidadeVendas") =>
    linhas.reduce((s, l) => s + l[campo], 0);
  return (
    <div className="card tbl-wrap">
      <table>
        <thead>
          <tr>
            <th>Forma</th>
            <th className="r">Vendas</th>
            <th className="r">Esperado</th>
            <th className="r">Contado</th>
            <th className="r">Diferença</th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((l) => (
            <tr key={l.formaPagamento}>
              <td>{FORMA_PAGAMENTO_ROTULO[l.formaPagamento]}</td>
              <td className="r">{l.quantidadeVendas}</td>
              <td className="r">{formatarReais(l.esperadoCentavos)}</td>
              <td className="r">{formatarReais(l.contadoCentavos)}</td>
              <td className="r">
                <Diferenca centavos={l.diferencaCentavos} />
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td>Total</td>
            <td className="r">{soma("quantidadeVendas")}</td>
            <td className="r">{formatarReais(soma("esperadoCentavos"))}</td>
            <td className="r">{formatarReais(soma("contadoCentavos"))}</td>
            <td className="r">
              <Diferenca centavos={soma("diferencaCentavos")} />
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}

export function ItensVendidos({ itens }: { itens: CaixaDetalhe["resumo"]["itens"] }) {
  if (itens.length === 0) return <div className="card vazio">Nenhum item vendido.</div>;
  return (
    <div className="card tbl-wrap">
      <table>
        <thead>
          <tr>
            <th>Item</th>
            <th>Categoria</th>
            <th className="r">Qtd</th>
            <th className="r">Valor</th>
          </tr>
        </thead>
        <tbody>
          {itens.map((i) => (
            <tr key={`${i.produtoId}-${i.nome}`}>
              <td className="quebra">{i.nome}</td>
              <td className="mudo">{i.categoria}</td>
              <td className="r">{i.quantidade}</td>
              <td className="r">{formatarReais(i.totalCentavos)}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={2}>Total</td>
            <td className="r">{itens.reduce((s, i) => s + i.quantidade, 0)}</td>
            <td className="r">{formatarReais(itens.reduce((s, i) => s + i.totalCentavos, 0))}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
